"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.weddingDate = void 0;
const date_1 = __importDefault(require("../date"));
exports.weddingDate = (0, date_1.default)('07.06.2022 16:00', 'DD.MM.YYYY hh:mm', 'ru');
